import { render, staticRenderFns } from "./NotificationsListItem.vue?vue&type=template&id=01e91013&scoped=true"
import script from "./NotificationsListItem.vue?vue&type=script&lang=js"
export * from "./NotificationsListItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationsListItem.vue?vue&type=style&index=0&id=01e91013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e91013",
  null
  
)

export default component.exports